//src/modules/dashboard/Dasboard.tsx
import React from 'react';

export const Dashboard: React.FC = () => {
  return (
    <div>
      <h1>Дашбоард</h1>
      <p>Компонент в разработке</p>
    </div>
  );
};